import React, { useEffect } from "react";
import { Box, Typography, Container,Grid } from "@mui/material";
import { motion} from "framer-motion";
import Footer from "./Footer";

const Bankingcs1 = () => {
    useEffect(() => {
            window.scrollTo(0, 0); // Scroll to top when component loads
          },[]);

  return (
    <Box  sx={{backgroundColor:"#C4D8E2"}}>

      {/* Hero Section */}
      <Box
        sx={{
          height: "100vh",
          backgroundImage: `url('/image/financeimg.jpg')`, // replace with your image
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          px: { xs: 3, md: 10 },
        }}
      >
        <Box maxWidth="1200px"  p={4} borderRadius={2}>
          <Typography variant="h1" sx={{ color: "white",  fontWeight:"bold" , fontSize: { xs: "28px", md: "70px" }}}>
         
          Major credit union invests in ServiceNow for digital transformation
          </Typography>
        </Box>
      </Box>

      {/* Business Needs Section */}
      <Container sx={{ py: 10 }}>
      <Typography variant="body1" sx={{ color: "#333", fontSize: "18px" }}>
      A major U.S. credit union sought a comprehensive IT business management platform as a key element of digital transformation and the means to coordinate future IT resources and investments in line with the organization's strategy.
          </Typography>
      <Typography variant="body1" sx={{ mt: 2, color: "#333", fontSize: "18px"  }} mb={8}>
      In response, the organization chose multiple solutions from ServiceNow to evaluate and prioritize IT investments across business units, optimize business processes, increase operational efficiency and confirm regulatory compliance.
        </Typography>
        
        <Typography variant="h4" fontWeight="bold" mb={3}>
          Business Needs
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        As a federally chartered credit union serving over 1.2 million members of the educational community across 69 locations, providing personal service and financial security remains top of mind.
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        In the face of these enduring commitments, the credit union has a clear vision for the future. With the banking and financial services sector juggling heightened competition, market volatility and shifting regulatory pressures, the organization pursued digital transformations to respond to market challenges and increase efficiency and customer-centricity.  </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={8}>
        The credit union partnered with Tech Informatic Solutions to digitize and streamline an array of business processes managed through multiple ServiceNow solutions.
        </Typography>



         {/* outcome Section */}
       <Typography variant="h4" fontWeight="bold" mb={-12}>
         Outcomes
        </Typography>
       
      </Container>
      <Container maxWidth="lg">
        <Grid container spacing={3} sx={{ mt: 4 }} mb={14}>
          {[
            {
              bgImage: "/image/f3.jpeg", // Replace with actual image path
              points: [
                "Captures, evaluates and prioritizes current IT investments",
                "Roadmaps IT transformations to align with business strategy",
                "Optimizes software licensing management and costs"
              ],
            },
            {
              bgImage: "/image/f2.jpeg", // Replace with actual image path
              points: [
                "Improves security, productivity and customer experience through application integrations",
                "Automates workflows for post-pandemic safe return to work",
                "Provides better governance and control across IT"
              ],
            },
          ].map((feature, index) => (
            <Grid item xs={12} md={6} key={index}>
              <motion.div
                whileHover={{ y: -5 }} // Jump effect on hover
                transition={{ type: "spring", stiffness: 200, damping: 10 }}
              >
                 <Box
                  sx={{
                    position: "relative",
                    backgroundImage: `url(${feature.bgImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    borderRadius: "12px",
                    p: 4,
                    minHeight: "250px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between", // ✅ Ensures equal spacing
                    overflow: "hidden",
                    textAlign: "left", // ✅ Left-aligned text
                  }}
                >
                  {/* Dark Overlay for Better Visibility */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      backgroundColor: "rgba(0, 0, 0, 0.6)", // Reduced brightness
                      zIndex: 1,
                    }}
                  />

                  {/* Bullet Points - Always Visible */}
                  <Box
                    sx={{
                      position: "relative",
                      zIndex: 2,
                      display: "flex",
                      flexDirection: "column",
                      gap: "30px", // ✅ Creates space between two bullet points
                      minHeight: "100%", // ✅ Ensures equal height
                      mt:6,
                    }}
                  >
                    {feature.points.map((point, i) => (
                      <Box
                        key={i}
                        sx={{
                          display: "flex",
                          alignItems: "flex-start", // ✅ Aligns bullet with text properly
                          gap: "8px",
                          color: "white",
                          minHeight: "50px", // ✅ Ensures each bullet aligns properly
                        }}
                      >
                        <Typography
                          component="span"
                          sx={{
                            fontSize: "1.5rem",
                            lineHeight: "1.5rem", // ✅ Ensures bullet stays aligned
                          }}
                        >
                          ✅
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: { xs: "1rem", md: "1.2rem" },
                            lineHeight: "1.5rem", // ✅ Ensures text stays in line
                          }}
                        >
                          {point}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>


{/* banner Section */}
<Box
        sx={{
          height: "50vh",
          backgroundImage: `url('/image/bankimg.jpg')`, // replace with your image
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          px: { xs: 3, md: 10 },
        }}
      >
        <Box maxWidth="1200px"  p={4} borderRadius={2}>
          <Typography variant="h1" sx={{ color: "white",  fontWeight:"bold" , fontSize: { xs: "22px", md: "42px" }}}>
         
          A prominent U.S. credit union harnessed the power of ServiceNow solutions to facilitate its digital transformation journey, enhancing business processes, regulatory compliance and efficient management of IT resources.
          </Typography>
        </Box>
      </Box>




      <Container sx={{ py: 10 }}>
      
       
      <Typography  variant="h4" fontWeight="bold" mb={3}>
      Solution
          </Typography>
        <Typography variant="h5" fontWeight="bold" mb={3}>
        Audit and then build a strategic roadmap
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        The credit union chose to partner with Tech Informatic Solutions based on its advisory-led approach as a ServiceNow Elite Partner and experience with ServiceNow deployments in the financial services industry each one.
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={8}>
        The first step in the engagement was assessing existing IT investments across business units by using ServiceNow Strategic Portfolio Management (SPM) to capture, evaluate and prioritize. After determining the future state, teams worked together to design a plan to bridge any gaps.
        </Typography>
        <Typography variant="h5" fontWeight="bold" mb={3}>
        Better returns with IT asset management
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        Once it had successfully set the foundation for its digital transformation, the credit union had the insight needed to prioritize current and new ServiceNow deployments. The need for better software asset management was addressed next. </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={3}>
        In the past, software deployment was easily controlled by the IT team, who had the skills to implement and maintain applications. However, over time, many of the organization's software purchases became decentralized, a trend that was particularly acute during the pandemic and the resulting period of remote work.. </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={8}>
        The transitioned server operations offer a performant and resilient platform to support current operations as well as a foundation for further hybrid infrastructure services.  </Typography>
        <Typography variant="h5" fontWeight="bold" mb={3}>
        Security, productivity and customer experience profit from integrations </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        The credit union sought to optimize its ServiceNow implementation further through integrations with other software services. As part of this, Tech Informatic Solutions advisory service provided education sessions on ServiceNow Flow Designer to aid in building a custom integration to the credit union’s instance of BeyondTrust Privileged Access Management (PAM).</Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={3}>
        The project also included deploying several out-of-the-box integrations for DocuSign, Cisco WebEx, Adobe and Microsoft 365 to support internal teams and deliver the customer experiences that financial consumers have come to expect.</Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={8}>
        The ability to support electronic signatures was critical to the continued sale of financial products throughout COVID-19, not to mention its potential for identity verification, supporting HR and streamlining the contracting process for the credit union's employees. </Typography>

</Container>



<Footer/>
    </Box>


  );
};

export default Bankingcs1;
